import { makeStyles } from '@material-ui/core/styles';

/**
 * Estilos comunes y utilidades para el módulo Registros de Uso
 * Estilos que pueden ser reutilizados en múltiples componentes
 */
export const useCommonStyles = makeStyles((theme) => ({
    // Contenedores
    paperContainer: {
        borderRadius: '30px',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
        padding: theme.spacing(2),
        backgroundColor: '#F5F8F9',
    },
    
    // Títulos
    pageTitle: {
        fontSize: '25px',
        fontWeight: 'bold',
        marginTop: '2.5%',
        marginBottom: '2%',
    },
    
    sectionTitle: {
        fontWeight: 700,
        fontSize: '18px',
        color: theme.palette.primary.main,
    },
    
    // Loading
    loadingContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '20px',
    },
    
    // Estados vacíos
    emptyState: {
        textAlign: 'center',
        padding: theme.spacing(4),
        color: theme.palette.text.secondary,
    },
    
    // Botones
    primaryButton: {
        borderRadius: '5px',
        textTransform: 'none',
        fontWeight: 'bold',
    },
    
    outlinedButton: {
        borderRadius: '20px',
        textTransform: 'none',
        fontWeight: 'bold',
    },
}));

export default useCommonStyles;
